import React from 'react';
import Icon from './styles/icon';
import httpClient from './myapi'
import { AddtoCart, RemoveFromCart } from './redux/actions/index'
import store from './redux/store/index';

const _webserver = httpClient.WebServerGallery;

class ImageCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            notLoaded: true,
            added2Cart: props.img.selected
        }

        this.onload = this.onload.bind(this)
        this.addToCart = this.addToCart.bind(this)
    }
    onload() {
        this.setState({
            notLoaded: false
        })
    }
    addToCart() {
        if (!this.state.added2Cart) {
            store.dispatch(AddtoCart(this.props.img.id))
        } else {
            store.dispatch(RemoveFromCart(this.props.img.id))
        }

        this.setState({
            added2Cart: !this.state.added2Cart
        })
    }

    render() {
        const { img, onclick, secondAction, isAdmin } = this.props;
        const blurImg = {
            backgroundImage: `url(` + img.base + `)`
        }
        return (
            <div className="img-card">
                {
                    img.catNm !== null &&
                    <div className="img-title">
                        <Icon icon="fa-folder-open" />
                        {' ' + img.catNm}
                    </div>
                }
                <div className="img-info">
                    <div className="text-info">
                        <div className="img-tags">
                            <Icon icon="fa-tag" />
                            <span>id: #{img.id}</span>
                        </div>
                        <div className="img-tags">
                            <Icon icon="fa-rupee-sign" />
                            <span>Price: {img.sprice}</span>
                        </div>
                        {
                            img.disc > 0 &&
                            <div className="img-tags">
                                <Icon icon="fa-haykal" />
                                <span>Discount: {img.disc}% Off</span>
                            </div>
                        }
                    </div>
                    <div className="btns">
                        <div className="v-icon-btn" onClick={onclick}>
                            <Icon icon="fa-search-plus" />
                        </div>
                        {
                            isAdmin
                                ? <div className="v-icon-btn" onClick={secondAction}>
                                    <Icon icon="fa-pencil-alt" />
                                </div>
                                : <div className="v-icon-btn" onClick={this.addToCart}>
                                    {
                                        this.state.added2Cart
                                            ? <Icon icon="fa-check" />
                                            : <Icon icon="fa-cart-plus" />
                                    }
                                </div>
                        }
                        {
                            isAdmin &&
                            <div className="v-icon-btn" 
                                    onClick={this.props.onDel}>
                                <Icon icon="fa-trash-alt" />
                            </div>
                        }
                    </div>
                </div>
                {
                    this.state.notLoaded &&
                    <div className="img-card-overlay">
                        <div className="img-placeholder" style={blurImg}></div>
                    </div>
                }
                <img src={_webserver + img.srcnm}
                    onLoad={this.onload} alt={"saree " + img.id}
                />
            </div >
        )
    }
}
export default ImageCard;


// WEBPACK FOOTER //
// ./src/ImageCard.jsx